import { render, staticRenderFns } from "./GestionePedane.vue?vue&type=template&id=6961c654&scoped=true&"
import script from "./GestionePedane.vue?vue&type=script&lang=js&"
export * from "./GestionePedane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961c654",
  null
  
)

export default component.exports